export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Browser starts the download asynchronously; revoking in the same task can
  // invalidate the blob URL before Chrome/Safari has consumed it.
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function downloadUrl(url: string): void {
  const link = document.createElement('a');

  link.href = url;
  link.target = '_self';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
